import React from "react";
import { Outlet } from "react-router-dom";

const AnalyticsOverviewContainer = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default AnalyticsOverviewContainer;
